
import { getLoyaltyLevelNumber } from '~~/helpers/getLoyaltyLevelNumber';

export const usePersonalizedDiscount = (productPrice?: number) => {

  const {
    loyaltyLevels,
    load: loadLoyaltyLevels,
    loading: loyaltyLevelsLoading,
  } = useCTLoyaltyLevels();
  const { customerTierKey, loading: userLoading, isLoggedIn } = useUserExtended();

  const load = async () => {

    await loadLoyaltyLevels();
  
  };

  const isLoading = computed(() => {

    return loyaltyLevelsLoading.value || userLoading.value;
  
  });

  const loyaltyLevel = computed(() => {

    if (!customerTierKey.value || !isLoggedIn.value) {

      return null;
    
    }

    if (!loyaltyLevels.value) {

      return null;

    }

    const levelNumber = getLoyaltyLevelNumber(customerTierKey.value);

    return loyaltyLevels.value.find(l => l.levelNumber === levelNumber) || null;
  
  });

  const personalizedDiscount = computed(() => {

    return loyaltyLevel.value?.discountPercentage || 0;
  
  });

  const hasPersonalizedDiscount = computed(() => {

    return !!personalizedDiscount.value && personalizedDiscount.value > 0;
  
  });

  const personalizedPrice = computed(() => {

    if (personalizedDiscount.value > 0 && productPrice) {

      return productPrice - (productPrice * personalizedDiscount.value) / 100;
    
    }

    return null;
  
  });

  return {
    load,
    personalizedDiscount,
    personalizedDiscountLoading: isLoading,
    hasPersonalizedDiscount,
    personalizedPrice,
  };

};
